var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvolution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5213 11.3915H1.58875V0.84059C1.58875 0.766193 1.52632 0.705322 1.45 0.705322H0.478754C0.402441 0.705322 0.340004 0.766193 0.340004 0.84059V12.4736C0.340004 12.548 0.402441 12.6089 0.478754 12.6089H13.5213C13.5976 12.6089 13.66 12.548 13.66 12.4736V11.5268C13.66 11.4524 13.5976 11.3915 13.5213 11.3915ZM3.42372 8.78251C3.47749 8.83492 3.56421 8.83492 3.61971 8.78251L6.01835 6.4559L8.23141 8.62695C8.28518 8.67936 8.37363 8.67936 8.42739 8.62695L13.2039 3.97204C13.2576 3.91963 13.2576 3.83339 13.2039 3.78098L12.5171 3.1114C12.491 3.08623 12.4558 3.0721 12.4191 3.0721C12.3824 3.0721 12.3471 3.08623 12.3211 3.1114L8.332 6.99866L6.12241 4.83099C6.09633 4.80582 6.06112 4.7917 6.02442 4.7917C5.98772 4.7917 5.9525 4.80582 5.92643 4.83099L2.73864 7.92017C2.71282 7.9456 2.69834 7.97993 2.69834 8.0157C2.69834 8.05148 2.71282 8.08581 2.73864 8.11124L3.42372 8.78251Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolution);
export default __webpack_public_path__ + "static/media/evolution.31cec45a.svg";
export { ForwardRef as ReactComponent };